export const LEADERBOARD_WINDOW_OPTIONS: Option[] = [
    {
      label: "Last 25",
      value: "last25Games",
    },
    {
      label: "Last 100",
      value: "last100Games",
    },
    {
      label: "All Time",
      value: "allTime",
    },
  ];
